<!-- Original Template -->
<div *ngIf="!enableMachCoreProfileSelector" class="profile-selector-ui">
  <div class="profile-selector-ui-wrapper">
    <div class="profile-selector-ui__header">
      <div
        id="profile-selector-closeIcon"
        class="profile-selector-ui-close-icon-box"
        *ngIf="!fromStandAlonePage"
      >
        <span>&nbsp;</span>
        <button
          role="button"
          type="button"
          aria-label="Close"
          (click)="onClose()"
        ></button>
      </div>
      <idp-profile-selector-header
        [profileHeaderContent]="profileDetails.pageHeader"
        [enableMachCoreProfileSelector]="enableMachCoreProfileSelector"
      ></idp-profile-selector-header>
    </div>
    <div class="profile-selector-ui__personal-selector">
      <idp-personal-profile-selector
        *ngIf="profileDetails && profileDetails.personalProfile"
        [pageData]="profileDetails.personalProfile"
        [personalStateSelected]="personalStateSelected"
        [enableMachCoreProfileSelector]="enableMachCoreProfileSelector"
        (personalProfileSelected)="personalProfileSelected($event)"
        (analyticsEvent)="handleProfileAnalytics($event)"
      ></idp-personal-profile-selector>
    </div>
    <div class="profile-selector-ui__divider"></div>
    <div class="profile-selector-ui__business-selector">
      <idp-business-profile-selector
        [pageData]="profileDetails.businessProfile"
        [businessStateSelected]="businessStateSelected"
        [enableMachCoreProfileSelector]="enableMachCoreProfileSelector"
        (emitCompanyTitle)="businessProfileSelected($event)"
        (analyticsEvent)="handleProfileAnalytics($event)"
      ></idp-business-profile-selector>
    </div>
    <div *ngIf="displayTermsOfUse">
      <p
        [innerHTML]="profileDetails.pageFooter.footerSubText"
        class="profile-selector-ui__footerSubText"
      ></p>
    </div>
    <div *ngIf="!displayTermsOfUse">
      <p
        [innerHTML]="profileDetails.pageFooter.footerSubTextWithoutToU"
        class="profile-selector-ui__footerSubText"
      ></p>
    </div>
  </div>
  <div class="profile-selector-ui__footer" *ngIf="!fromStandAlonePage">
    <idp-button
      [ariaLabel]="'Log Out'"
      [type]="'link'"
      [label]="'Log Out'"
      [size]="'full-width'"
      (notify)="emitLogout($event)"
    ></idp-button>
  </div>
</div>

<!-- New MachCore Template -->
<div
  *ngIf="enableMachCoreProfileSelector"
  class="profile-selector-machcore flex flex-col justify-between !min-h-[500px] !max-h-[700px]"
>
  <div class="profile-selector-machcore-wrapper">
    <div class="profile-selector-machcore__header">
      <div
        id="profile-selector-closeIcon-machcore"
        class="profile-selector-machcore-close-icon-box"
        *ngIf="!fromStandAlonePage"
      ></div>
      <idp-profile-selector-header
        [profileHeaderContent]="profileDetails.pageHeader"
        [enableMachCoreProfileSelector]="enableMachCoreProfileSelector"
      ></idp-profile-selector-header>
    </div>
    <div class="profile-selector-machcore__personal-selector">
      <idp-personal-profile-selector
        *ngIf="profileDetails && profileDetails.personalProfile"
        [pageData]="profileDetails.personalProfile"
        [personalStateSelected]="personalStateSelected"
        [enableMachCoreProfileSelector]="enableMachCoreProfileSelector"
        (personalProfileSelected)="personalProfileSelected($event)"
        (analyticsEvent)="handleProfileAnalytics($event)"
      ></idp-personal-profile-selector>
    </div>
    <div
      class="profile-selector-machcore__divider border border-[#e8ecf2] my-[14px]"
    ></div>
    <div class="profile-selector-machcore__business-selector">
      <idp-business-profile-selector
        [pageData]="profileDetails.businessProfile"
        [businessStateSelected]="businessStateSelected"
        [enableMachCoreProfileSelector]="enableMachCoreProfileSelector"
        (emitCompanyTitle)="businessProfileSelected($event)"
        (analyticsEvent)="handleProfileAnalytics($event)"
      ></idp-business-profile-selector>
    </div>
  </div>
  <div class="">
    <div class="my-[14px]" *ngIf="displayTermsOfUse">
      <p
        [innerHTML]="profileDetails.pageFooter.footerSubText"
        class="profile-selector-machcore__footerSubText text-[#697180] font-[400] text-[11px] leading-[.975rem]"
      ></p>
    </div>
    <div class="my-[14px]" *ngIf="!displayTermsOfUse">
      <p
        [innerHTML]="profileDetails.pageFooter.footerSubTextWithoutToU"
        class="profile-selector-machcore__footerSubText text-[#697180] font-[400] text-[11px] leading-[.975rem]"
      ></p>
    </div>
    <div
      *ngIf="!fromStandAlonePage"
      class="profile-selector-machcore__footer flex justify-center flex-col items-center bg-[#f5f7fa] py-[12px] border-t border-[#e6eaf2]"
    >
      <span
        tabindex="0"
        (click)="emitLogout($event)"
        [attr.data-acdl-action]="
          'header profile selector flyout:logout cta click'
        "
        [attr.data-acdl-page-section]="'header:profile selector flyout'"
        [attr.data-acdl-name]="'logout'"
        class="text-[#4470c3] font-[600] text-[13px] cursor-pointer"
      >
        Log Out
      </span>
    </div>
  </div>
</div>
